export default __webpack_public_path__ + "static/media/1487.655369cf.png";